export const worldClocks = [
  { code: 'DXB', city: 'Dubai', timeZone: 'Asia/Dubai', weekend: [0, 6] },
  { code: 'ZRH', city: 'Zurich', timeZone: 'Europe/Zurich', weekend: [0, 6] },
  { code: 'WAW', city: 'Warsaw', timeZone: 'Europe/Warsaw', weekend: [0, 6] },
];
